import Area from './components/area';
import Bar from './components/bar';
import Bullet from './components/bullet';
import Column from './components/column';
import Funnel from './components/funnel';
import Histogram from './components/histogram';
import Line from './components/line';
import Box from './components/box';
import Liquid from './components/liquid';
import Heatmap from './components/heatmap';
import Pie from './components/pie';
import Gauge from './components/gauge';
import Progress from './components/progress';
import Radar from './components/radar';
import RingProgress from './components/ring-progress';
import Rose from './components/rose';
import Chord from './components/chord';
import Scatter from './components/scatter';
import TinyArea from './components/tiny-area';
import TinyColumn from './components/tiny-column';
import DualAxes from './components/dual-axes';
import TinyLine from './components/tiny-line';
import Waterfall from './components/waterfall';
import WordCloud from './components/word-cloud';
import Sunburst from './components/sunburst';
import Stock from './components/stock';
import RadialBar from './components/radial-bar';
import Sankey from './components/sankey';
import Treemap from './components/treemap';
import Violin from './components/violin';
import Venn from './components/venn';
import CirclePacking from './components/circle-packing';
import Facet from './components/facet';
import MultiView from './components/mix'; // 和 Mix 相同
import Mix from './components/mix';
import BidirectionalBar from './components/bidirectional-bar';
import { G2, flow, measureTextWidth, adaptors, getCanvasPattern, FUNNEL_CONVERSATION_FIELD } from '@antv/g2plot';

export {
  Area,
  Bar,
  Box,
  Bullet,
  Column,
  Funnel,
  Histogram,
  Line,
  Liquid,
  Heatmap,
  Pie,
  Progress,
  Radar,
  Facet,
  RingProgress,
  Rose,
  Chord,
  Scatter,
  TinyArea,
  TinyColumn,
  TinyLine,
  Waterfall,
  WordCloud,
  Sunburst,
  DualAxes,
  Stock,
  RadialBar,
  CirclePacking,
  Gauge,
  Sankey,
  Treemap,
  Violin,
  Venn,
  MultiView,
  Mix,
  BidirectionalBar,
  G2,
  // 直接导出 G2Plot 相关方法
  getCanvasPattern,
  FUNNEL_CONVERSATION_FIELD,
  flow,
  measureTextWidth,
  adaptors,
};

export default {
  Area,
  Bar,
  Box,
  Bullet,
  Column,
  Funnel,
  Histogram,
  Line,
  Liquid,
  Heatmap,
  Pie,
  Progress,
  Radar,
  Facet,
  RingProgress,
  Rose,
  Chord,
  Scatter,
  TinyArea,
  TinyColumn,
  TinyLine,
  Waterfall,
  WordCloud,
  Sunburst,
  DualAxes,
  Stock,
  RadialBar,
  Gauge,
  CirclePacking,
  Sankey,
  Treemap,
  Violin,
  Venn,
  MultiView,
  Mix,
  BidirectionalBar,
  // 直接导出 G2Plot 相关方法
  getCanvasPattern,
  FUNNEL_CONVERSATION_FIELD,
  G2,
  flow,
  measureTextWidth,
  adaptors,
};

export * from './interface';
